import React from 'react'
import SimpleModal from 'components/SimpleModal'
import { ModalIndicacaoWrapper, CloseIconRed } from 'views/simulacao/style'
import { MetodosFgts } from 'store/modules/simulacao/types'
import useRedux from 'hooks/useRedux'
import * as simulacaoActions from 'store/modules/simulacao/actions'

interface Indicacao {
  isOpen: boolean
  toggle: () => void
  metodo: MetodosFgts | null
}

const Indicacao3 = ({ isOpen, toggle, metodo }: Indicacao) => {
  const { dispatch } = useRedux()
  function onToggle() {
    if (metodo === MetodosFgts.SolicitarSimulacao) {
      dispatch(simulacaoActions.getParcelasFgtsSaga())
    }
    toggle()
  }
  return (
    <SimpleModal toggle={onToggle} isOpen={isOpen} size="lg">
      <ModalIndicacaoWrapper>
        <div className="container-fluid d-flex flex-column row-gap-15 position-relative">
          {/* Botão de fechar estilizado */}
          <button
            onClick={onToggle}
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              background: 'none',
              border: 'none',
              fontSize: '20px',
              cursor: 'pointer',
              color: 'gray'
            }}
            aria-label="Close"
          >
            &times;
          </button>
        </div>
        <div className="container-fluid d-flex flex-column row-gap-15">
          <div className="d-flex justify-content-center">
            <CloseIconRed />
          </div>
          <h3 className="main-title">
            Ops... parece que você já antecipou seu saque aniversário do FGTS
          </h3>
          <p className="text-center common-text">
            Aproveite para conhecer a conta digital que é uma excelente opção:
            saque grátis ilimitado, transferência grátis para qualquer banco,
            cartão de crédito sem anuidade e com cashback, dentre muitas outras.
            E você ainda pode contratar 100% online.
          </p>
          {/* <Row>
            <Col>
              <div className="d-flex justify-content-center">
                <img src={qrCode} />
              </div>
            </Col>
          </Row> */}
          {/* <Row>
            <Col className="d-flex align-items-center justify-content-center">
              <CustomButtonLink
                background="var(--roxo-riber)"
                href="http://www.bancobmg.com.br/mgm/redir?key=ab250b55"
                target="_blank"
                onClick={() => {
                  toggle()
                }}
              >
                ABRIR MINHA CONTA
              </CustomButtonLink>
            </Col>
          </Row> */}
        </div>
      </ModalIndicacaoWrapper>
    </SimpleModal>
  )
}

export default Indicacao3
